import { AbstractControl } from '@angular/forms';

export function isDateValid(control: AbstractControl) {
  // not to validate empty value
  if (!control.value) {
    return null;
  }

  return control.value && control.value.length === 10 ? null : { date: true };
}

export function isMomentDateValid(control: AbstractControl) {
  if (!control.value) {
    return null;
  }

  const date = new Date(control.value._d).getTime();

  return control.value &&
    control.value._isValid &&
    date >= new Date('1900-01-01').getTime() &&
    date <= new Date().getTime()
    ? null
    : { date: true };
}
